import { BCMSDate } from "@bcm-dev/bcms-vite";
import { SVGAsset } from "res";
import "./styles.css";
export default function PickerHeader(props) {
    let { month1,  setViewDate, enablePast,enableFuture } = props; 
const setToday = ()=>(
   setViewDate(BCMSDate.init()) 
)
let disablePast = (date)=>{return enablePast ? enablePast :BCMSDate.init(date).setToFirst().isAfter(BCMSDate.init().setToFirst()) } 
let disableFuture = (date)=>{return enableFuture ? enableFuture :BCMSDate.init(date).setToFirst().isBefore(BCMSDate.init().setToFirst()) } 
    return (
        <div className="picker-header">
            <div className="date-select-month text-center">
                <span className="left-calendar-label">
                    <span className='month'>{month1.getLongMonth} </span> 
                    <span className='year'>{month1.yearInt}</span> 
                </span>
            </div>  
            <div className="flex-container flex-horizontal align-center">
                <div className="left-container flex-width flex-container flex-horizontal align-center">
                    <div className="flex-width text-left">
                        <YearLeft setViewDate={setViewDate} viewDate={month1} disabled={disablePast} enablePast={enablePast}/>
                    </div>
                    <div className="flex-width">
                        <MonthLeft setViewDate={setViewDate} viewDate={month1} disabled={disablePast} />
                    </div>
                </div>
                <span className="flex-width clickable" onClick={setToday}><b>Today</b></span> 
                <div className="right-container flex-width flex-container flex-horizontal align-center">
                    <div className="flex-width">
                        <MonthRight setViewDate={setViewDate} viewDate={month1} disabled={disableFuture} />
                    </div>
                    <div className="flex-width text-right">
                        <YearRight setViewDate={setViewDate} viewDate={month1} disabled={disableFuture} enableFuture={enableFuture}/>
                    </div>
                </div>
            </div>  
        </div>
    )
}

export function MonthLeft(props) {
    let {disabled, setViewDate, viewDate} = props;
    let onClick = function () {
        if (disabled(viewDate) !== false) {
            setViewDate(viewDate.offset([0, -1, 0]))
        }
    }
    return (
        <button className={`left-button ${disabled(viewDate) === false ? "disabled-month-chevron":""}`} onClick={onClick}> <SVGAsset id="LeftChevronIcon" /> </button>
    )
}

export function MonthRight(props) {
    let {disabled, setViewDate, viewDate} = props;
    let onClick = function () {
        if (disabled(viewDate) !== false) {
        setViewDate(props.viewDate.offset([0, 1, 0]))
        }
    }
    return (
        <button className={`right-button ${disabled(viewDate) === false ? "disabled-month-chevron":""}`} onClick={onClick}> <SVGAsset id="RightChevronIcon" /> </button>
    )
}


export function YearLeft(props) {
    let {disabled, setViewDate, viewDate,enablePast} = props;
    let onClick = function () {
       
        if (disabled(viewDate) !== false) {
            if(enablePast){
                setViewDate(viewDate.offset([0, 0, -1]))
            }else{
                setViewDate(viewDate.offset([0, 0, -1]).isPast()?BCMSDate.init():viewDate)
            }
            
        }
      
    }
    return (
        <button className={`left-button ${disabled(viewDate) === false  ? "disabled-month-chevron":""}`} onClick={onClick}> <SVGAsset id="LeftDoubleChevronIcon" /> </button>
    )
}

export function YearRight(props) {
    let {disabled, setViewDate, viewDate,enableFuture} = props;
    let onClick = function () {
        if (disabled(viewDate) !== false ) {
            if(enableFuture){
                setViewDate(props.viewDate.offset([0, 0, 1]))
            }else{
                setViewDate(viewDate.offset([0, 0, 1]).isFuture()?BCMSDate.init():viewDate)
            }
       
        }
    }
    return (
        <button className={`right-button ${disabled(viewDate) === false  ? "disabled-month-chevron":""}`} onClick={onClick}> <SVGAsset id="RightDoubleChevronIcon" /> </button>
    )
}
